@if (dateSelected) {
  <div class="display-flex h-100">
    <div class="px-0 d-flex mt-1 mb-1 align-items-center justify-content-center">
      <div class="px-1">
        <button
          class="btn btn-secondary font-size-10 btn-sm text-uppercase border-radius-15 d-flex align-items-center"
          [ngClass]="{'pointer-events-none opacity-6': resetDisabled}"
          [appUITooltip]="false"
          [placement]="'top'"
          [trigger]="'hover'"
          i18n="@@app.reset"
        (click)="resetExpectedProjectDate()">Reset</button>
      </div>
    </div>
  </div>
}
